/**
 * Portrait + background changer locale pack: ja
 */

module.exports = {
  "portrait": {
    "overview": [
      "Miral AI Background Remover はサインイン後に無料で使えます。肩から上のポートレート—LinkedIn写真、履歴書用、WeChatやInstagramのアバター、証明写真用の透明マスター—に向いています。",
      "シャープな JPG、PNG、または WebP（最大 15 MB）をアップロードしてください。AI が人物を自動検出します。ダウンロード前に、飛び出した髪、メガネ、イヤリング、襟のラインを拡大確認しましょう。",
      "透明 PNG は、完成した白や青の証明写真ではありません。まず透明マスターを残し、そのあと必要な色を足して公式サイズに切り抜いてください。"
    ],
    "practice": [
      "できるだけカメラのオリジナルから始めます。チャットアプリのサムネイルや強い美肌フィルターは髪のエッジをぼかし、メガネのフレームを保ちにくくします。",
      "切り抜きは必ず明るいキャンバスと暗いキャンバスの両方に置きます。この一手で、薄いハロや消えた髪の毛がすぐ分かります。"
    ],
    "compareIntro": "このガイドは人物向けです—アバター、証明写真風、プロのヘッドショット。商品の白背景は EC ガイド、切り抜き後にカフェやオフィスのシーンが欲しいときは背景差し替えガイドを使ってください。",
    "workflow": "15 MB までのクリアなポートレートをアップロードし、AI に背景全体を除去させ、髪とメガネを確認してから透明 PNG をダウンロードし、白・青・ブランド色を足します。",
    "scenarioIntro": "自分の用途に近いポートレートの仕事を選び、その用途で失敗しやすいエッジを重点的に確認してください。",
    "sec": {
      "tldrTitle": "短い答え",
      "tldrCols": [
        "必要なこと",
        "詳細"
      ],
      "tldrRows": [
        [
          "料金",
          "Miral AI Background Remover はサインイン後に無料"
        ],
        [
          "アップロード",
          "JPG、PNG、または WebP（最大 15 MB）"
        ],
        [
          "向いている用途",
          "LinkedIn ヘッドショット、履歴書写真、アバター、証明写真マスター"
        ],
        [
          "ダウンロード",
          "透明 PNG。白や青はあとから追加"
        ],
        [
          "重点確認",
          "髪、メガネ、イヤリング、襟、肩"
        ],
        [
          "この記事ではないもの",
          "マーケットプレイス商品の白背景は EC ガイドへ"
        ]
      ],
      "tldrP": "街の自撮りや急いだオフィスのスナップでも、Miral AI ならきれいなヘッドショットにできます。一度切り抜き、透明ファイルを残し、そのあと本当に必要な白・青・ブランド色版を作ってください。",
      "whatTitle": "アバター、証明写真、LinkedIn ヘッドショットにそれぞれ必要なこと",
      "whatP1": "3つの用途とも最初の一歩は同じです。Miral AI Background Remover で人物を切り抜き、きれいな透明 PNG を残すこと。違いは、あとから足す色と切り抜きサイズです。",
      "whatAvatarP": "アバター背景除去が解決すること：寝室の自撮りや街スナップは顔を散らかした背景に埋もれさせます。背景を消し、ブランド色や単色に載せ、Instagram・WeChat・個人サイト用の円形クロップをプレビューしてください。",
      "galleryAvatarCaption": "アバター例：左は散らかった室内自撮り、右は円形プロフィール用に単色へ載せた切り抜き。",
      "whatIdP": "証明写真の背景除去が解決すること：申請では白や青が求められることが多いです。リビングのスナップはそのルールに合いません。一度切り抜き、必要な色を足し、公式サイズにクロップします。提出前に必ず最新のフォーム規定を再確認してください。",
      "galleryIdCaption": "証明写真例：左は忙しい自宅背景、右はサイズ調整用の純白背景に載せた同じ人物。",
      "whatLinkedInP": "LinkedIn ヘッドショットの切り抜きが解決すること：オープオフィスではモニターや同僚が背後に入ります。落ち着いた灰や白の背景なら、採用担当者が最初に見る顔と服装に視線が戻ります。",
      "galleryLinkedInCaption": "LinkedIn 例：左は忙しいオフィス自撮り、右は採用向けのソフトグレー背景に載せた切り抜き。",
      "whatTipTitle": "3用途とも同じ透明マスター",
      "whatTipText": "まず透明 PNG をダウンロードしてください。ブランド色アバター、白/青の証明写真書き出し、ソフトグレーの LinkedIn カードは、すべて同じファイルから派生させます。",
      "howTitle": "使えるヘッドショットまでの 4 ステップ",
      "howP": "Miral AI Background Remover を開き、肩から上の写真をアップロードし、自動検出を待ち、ダウンロード前に髪とメガネを 100% で拡大確認します。エッジがきれいになってから白や青を足してください。",
      "howTipTitle": "オリジナルファイルを優先",
      "howTipText": "強い美肌フィルターやメッセージアプリの圧縮は飛び出した髪をぼかします。カメラのオリジナルがほぼ常に勝ちます。",
      "edgeTitle": "ポートレートで失敗しやすいところ",
      "edgeCols": [
        "部位",
        "よくある失敗",
        "確認方法"
      ],
      "edgeRows": [
        [
          "飛び出した髪",
          "背景として消される",
          "暗いキャンバスと明るいキャンバスの両方で見る"
        ],
        [
          "メガネ",
          "テンプル欠落やレンズの穴",
          "フレームの角を拡大"
        ],
        [
          "イヤリング / 細いチェーン",
          "金属線が途切れる",
          "ジュエリーの輪郭を追う"
        ],
        [
          "襟とブレザーのライン",
          "白ハロやギザギザの肩",
          "暗いキャンバスに置く"
        ],
        [
          "ひげやもみあげ",
          "産毛がならされる",
          "素材のレタッチを弱めて再試行"
        ]
      ],
      "edgeP": "サムネイルで「大丈夫そう」では足りません。2色の背景で実寸確認するのがいちばん速い正直テストです。",
      "useTitle": "アバター、LinkedIn、履歴書、証明写真風",
      "useCols": [
        "用途",
        "典型的な背景",
        "実務メモ"
      ],
      "useRows": [
        [
          "LinkedIn / 求人サイト",
          "ソフトグレー、白、またはきれいなぼかし",
          "顔をシャープに。静かな背景が勝つ"
        ],
        [
          "WeChat / Instagram アバター",
          "ブランド色やシンプルなグラデーション",
          "投稿前に円形クロップをプレビュー"
        ],
        [
          "履歴書添付",
          "白またはライトグレー",
          "頭上と肩下に余白を残す"
        ],
        [
          "一般的な証明写真風プリント",
          "白または青",
          "透明 PNG に必要色を足してからクロップ"
        ],
        [
          "パスポート / ビザ写真",
          "現行の公式ルールに従う",
          "色・表情・メガネ規定は国によって異なる"
        ],
        [
          "講座や配信のカバー",
          "ブランド色または後からのシーン",
          "まずきれいに切り抜き、そのあとカバーをデザイン"
        ]
      ],
      "useTipTitle": "ルールは変わる",
      "useTipText": "ビザや試験写真の規定は国と年で違います。ツールは被写体をきれいにしますが、コンプライアンスは公式チェックリストから来ます。",
      "hairTitle": "髪の切り抜きとメガネ",
      "hairItems": [
        "逆光の飛び出し髪には、よりシンプルでコントラストの高い素材が必要です。",
        "メガネがある場合、両テンプルとレンズ領域が残っているか確認します。",
        "暗い壁の前の黒髪は出発点として不利です—可能なら明るい壁の近くへ。",
        "白い壁の前の明るいセーターは肩のエッジを失いやすいので、撮影背景を変えてください。",
        "長いカールや子どもの飛び出し髪は、ダウンロード前に必ず 100% 拡大確認を。"
      ],
      "hairP": "大きな服の形がポートレート切り抜きを壊すことは稀です。髪とメガネが壊します。そこに余分な1分を使います。",
      "troubleTitle": "ヘッドショットがおかしいとき",
      "troubleCols": [
        "問題",
        "想定原因",
        "試すこと"
      ],
      "troubleRows": [
        [
          "髪のかたまりが欠ける",
          "柔らかい・圧縮・逆光の素材",
          "美肌を弱めたシャープなオリジナルを使う"
        ],
        [
          "顔や肩の薄い縁",
          "旧背景色がエッジに残る",
          "暗いキャンバスで確認し、コントラストを上げて再試行"
        ],
        [
          "メガネフレームが途切れる",
          "強い反射が輪郭を混乱させる",
          "レンズへの光を柔らかくして再撮影"
        ],
        [
          "服が壁に溶ける",
          "被写体と背景のコントラスト不足",
          "同じファイルの再送ではなく背景を変える"
        ],
        [
          "証明写真が黄色っぽい",
          "素材のホワイトバランスが暖かい",
          "先に切り抜き、最終キャンバスで色を中和"
        ]
      ],
      "troubleTipTitle": "入力を変える",
      "troubleTipText": "同じ柔らかい自撮りを再送しても髪は直りません。きれいな素材の方が効きます。",
      "prosConsTitle": "役立つ点—そして自分で決める点",
      "bestTitle": "アバターを使える状態にする習慣",
      "bestItems": [
        "髪の上に少し余白のある肩から上の構図を使う。",
        "表情は自然に。切り抜き前の強い美肌は避ける。",
        "毎回、明るいキャンバスと暗いキャンバスで PNG を確認する。",
        "透明マスター、色付き証明写真書き出し、最終クロップを別ファイルで保存する。",
        "求人プラットフォームでは、静かな背景の方が顔と服装が読みやすい。",
        "次にカフェやオフィスの雰囲気が必要なら、まずきれいに切り抜き、背景差し替えガイドへ。"
      ],
      "miralTitle": "切り抜きのあとにやること",
      "miralP": "Miral AI ではポートレートをシャープにしたり、静かなアバターカードを作ったり、Seedream や FLUX.2 でカバーシーンを続けられます。ライフスタイル背景の差し替えは AI 背景差し替えガイドへ。商品リストの白背景は EC ガイドを使ってください。",
      "miralLinksTitle": "次のステップ",
      "miralLinks": [
        {
          "label": "Miral AI Background Remover",
          "path": "/tools/background-remover"
        },
        {
          "label": "AI背景差し替えガイド",
          "path": "/hub/articles/ai-background-changer-online"
        },
        {
          "label": "一般向けAI背景除去ガイド",
          "path": "/hub/articles/ai-background-remover-online"
        },
        {
          "label": "EC商品背景ガイド",
          "path": "/hub/articles/ecommerce-product-background-removal"
        },
        {
          "label": "AI Image Enhancer",
          "path": "/tools/image-enhancer"
        },
        {
          "label": "Seedream 5",
          "path": "/image-models/seedream-ai-image-generator"
        },
        {
          "label": "FLUX.2",
          "path": "/image-models/flux-2-ai-image-generator"
        }
      ],
      "intentsTitle": "よくあるポートレートの流れ",
      "faqTitle": "アップロード前によくある質問",
      "faqItems": [
        [
          "オンラインでポートレート背景を無料で消すには？",
          "Miral AI にサインインし、肩から上の JPG、PNG、または WebP をアップロードし、透明 PNG をダウンロードします。"
        ],
        [
          "自撮りから白や青の証明写真を作るには？",
          "まず透明 PNG を書き出し、必要な白や青を足し、公式サイズにクロップして提出前に最新規定を再確認します。"
        ],
        [
          "背景除去で LinkedIn ヘッドショットを作るには？",
          "忙しいオフィス背景を消し、ソフトグレーまたは白に載せ、アップロード前に髪と肩のエッジを確認します。"
        ],
        [
          "WeChat や Instagram のアバター背景を無料で消せますか？",
          "はい。サインインし、アバターのオリジナルを処理し、ブランド色の上で円形クロップをプレビューします。"
        ],
        [
          "メガネ付きの写真をオンラインで切り抜けますか？",
          "はい。ただしダウンロード前にフレーム、テンプル、レンズ領域を拡大確認してください。"
        ],
        [
          "ポートレートの髪の切り抜きに使えるツールは？",
          "カメラのオリジナルで Miral AI Background Remover を使い、明るいキャンバスと暗いキャンバスの両方で飛び出し髪を確認します。"
        ],
        [
          "パスポート写真の背景準備に使えるツールは？",
          "まず透明ポートレートマスターを作り、公式の背景色とミリサイズで書き出します。"
        ],
        [
          "ポートレート背景除去後の白ハロを直すには？",
          "透明 PNG を暗いキャンバスに置いて縁を特定し、よりシャープでコントラストの高いオリジナルで再試行します。"
        ],
        [
          "カールや子どもの写真で消えた飛び出し髪を直すには？",
          "強い美肌とチャットサムネイルを避け、よりクリアなオリジナルを使い、ダウンロード前に 100% で確認します。"
        ],
        [
          "プロのヘッドショットを一括処理できますか？",
          "現行ページは髪のエッジを確認できるよう、1枚ずつ処理します。"
        ],
        [
          "透明と白の証明写真背景の違いは？",
          "透明 PNG はあとからどの色にもできます。白の証明写真書き出しはフォームや履歴書用に白ピクセルを含みます。"
        ],
        [
          "そのあとカフェやオフィスのシーンに背景を変えるには？",
          "透明 PNG が確認を通ったら、AI 背景差し替えガイドに従い、照明の一致を確認します。"
        ]
      ]
    },
    "linksTitle": "Miral AI で続ける",
    "linksIntro": "透明ポートレートマスターを残し、強化したり、アバターカードを作ったり、ライフスタイルシーンへ進んでください。",
    "links": [
      {
        "label": "Miral AI Background Remover",
        "path": "/tools/background-remover"
      },
      {
        "label": "AI背景差し替えガイド",
        "path": "/hub/articles/ai-background-changer-online"
      },
      {
        "label": "一般向けAI背景除去ガイド",
        "path": "/hub/articles/ai-background-remover-online"
      },
      {
        "label": "EC商品背景ガイド",
        "path": "/hub/articles/ecommerce-product-background-removal"
      },
      {
        "label": "AI Image Enhancer",
        "path": "/tools/image-enhancer"
      },
      {
        "label": "Seedream 5",
        "path": "/image-models/seedream-ai-image-generator"
      },
      {
        "label": "FLUX.2",
        "path": "/image-models/flux-2-ai-image-generator"
      }
    ],
    "steps": [
      {
        "title": "クリアな肩から上の写真を選ぶ",
        "text": "顔と肩が完全に見える JPG、PNG、または WebP（最大 15 MB）を使います。"
      },
      {
        "title": "背景を自動除去する",
        "text": "Miral AI Background Remover が人物を検出し、背景全体を消します—手描き輪郭は不要です。"
      },
      {
        "title": "髪とメガネを確認する",
        "text": "飛び出し髪、フレーム、イヤリング、襟のラインを拡大します。"
      },
      {
        "title": "透明 PNG をダウンロードし、色を足す",
        "text": "マスターを残し、最終用途に白、青、グレー、ブランド色を追加します。"
      }
    ],
    "pros": [
      "アバターや証明写真風で使うポートレートエッジ向け",
      "髪に Photoshop のペンツールが不要",
      "1枚の透明 PNG から多くの背景色を作れる",
      "サインイン後にブラウザ内で無料処理"
    ],
    "cons": [
      "細い髪は実寸確認が必要",
      "逆光や低コントラストでエッジが柔らかくなることがある",
      "現行ページは1枚ずつ",
      "公式の証明写真規定は手動のコンプライアンス確認が必要"
    ],
    "tips": [
      {
        "title": "キャンバス色を2つ確認",
        "text": "明るい背景と暗い背景でハロや欠けた髪がすぐ分かります。"
      },
      {
        "title": "メガネとジュエリーを守る",
        "text": "ダウンロード前にテンプル、レンズの角、細いチェーンを拡大します。"
      },
      {
        "title": "マスターと証明写真書き出しを分ける",
        "text": "透明 PNG をフラットな白や青のファイルで上書きしないでください。"
      },
      {
        "title": "フィルターは控えめに",
        "text": "強い美肌はモデルが必要とする正確なエッジをぼかします。"
      },
      {
        "title": "次に開くガイドを知る",
        "text": "シーン差し替え → 背景チェンジャー。商品の白 → EC ガイド。"
      }
    ],
    "scenarios": [
      {
        "title": "LinkedIn ヘッドショットの背景除去",
        "text": "シャープな肩から上を切り抜き、アップロード前にソフトグレーまたは白に載せます。"
      },
      {
        "title": "WeChat / Instagram アバター切り抜き",
        "text": "透明 PNG をダウンロードし、ブランド色の上で円形クロップをプレビューします。"
      },
      {
        "title": "履歴書写真の白背景",
        "text": "透明マスターを残し、PDF 用に別の白背景ファイルを書き出します。"
      },
      {
        "title": "青背景の証明写真風",
        "text": "髪のエッジがきれいになってから必要な青を足します。"
      },
      {
        "title": "オンラインで髪まわりの背景を消す",
        "text": "カメラのオリジナルを使い、明るいキャンバスと暗いキャンバスで飛び出し髪を確認します。"
      },
      {
        "title": "メガネ付きポートレート切り抜き",
        "text": "ダウンロードを信頼する前にフレームの角とテンプルを拡大します。"
      },
      {
        "title": "パスポート写真の準備",
        "text": "まず透明 PNG を作り、その国の現行サイズと色の規定に従います。"
      },
      {
        "title": "オフィス自撮りからプロのヘッドショットへ",
        "text": "廊下の散らかりを消し、自然な表情を保ち、強いフィルターを避けます。"
      },
      {
        "title": "子どもやカール髪の切り抜き",
        "text": "飛び出し髪が増えがちです。必ず 100% で確認します。"
      },
      {
        "title": "透明 vs 白のポートレート背景",
        "text": "透明は再利用可能。白は特定フォーム向けのフラット書き出しです。"
      },
      {
        "title": "顔切り抜きの白ハロを直す",
        "text": "暗いキャンバスで縁を確認し、素材のコントラストを上げて再試行します。"
      },
      {
        "title": "ポートレート切り抜きからカフェシーンへ",
        "text": "透明 PNG が確認を通ったら背景差し替えガイドを使います。"
      }
    ],
    "toolFaq": [
      {
        "q": "オンラインでポートレート背景を無料で消すには？",
        "a": "サインインし、ポートレートをアップロードし、デスクトップソフトなしで透明 PNG をダウンロードします。"
      },
      {
        "q": "自撮りから白や青の証明写真を作るには？",
        "a": "背景を消し、透明 PNG を残し、必要な色を足して公式サイズにクロップします。"
      },
      {
        "q": "WeChat や Instagram のアバター背景を無料で消せますか？",
        "a": "はい。サインイン後にアバターのオリジナルを処理し、ブランド色の上で円形クロップをプレビューします。"
      },
      {
        "q": "メガネ付きの写真をオンラインで切り抜けますか？",
        "a": "はい。ダウンロード前にテンプルとレンズ領域を実寸で確認してください。"
      },
      {
        "q": "ポートレートの髪の切り抜きに使えるツールは？",
        "a": "シャープなオリジナルで Miral AI Background Remover を使い、明るいキャンバスと暗いキャンバスで飛び出し髪を確認します。"
      },
      {
        "q": "パスポート写真の背景準備に使えるツールは？",
        "a": "まず透明ポートレートマスターを作り、フォームが求める公式の色とサイズで書き出します。"
      },
      {
        "q": "ポートレート背景除去後の白ハロを直すには？",
        "a": "暗いキャンバスで縁を確認し、よりシャープでコントラストの高い素材で再試行します。"
      },
      {
        "q": "カールや子どもの写真で消えた飛び出し髪を直すには？",
        "a": "強い美肌とチャットサムネイルを避け、よりクリアなオリジナルを使い 100% で確認します。"
      },
      {
        "q": "プロのヘッドショットを一括処理できますか？",
        "a": "現行ページは1枚ずつ処理します。"
      },
      {
        "q": "そのあとカフェシーンに背景を変えるには？",
        "a": "確認済みの透明 PNG を AI 背景差し替えワークフローで使います。"
      }
    ]
  },
  "changer": {
    "overview": [
      "背景変更は2ステップが最もうまくいきます。無料の背景除去で透明 PNG を作り、そのあと新しいシーン—カフェの光、静かなオフィス、ブランドウォール、屋外の昼光—に配置します。",
      "切り抜きは Miral AI Background Remover が担当します。そのあと Seedream や FLUX.2 でライフスタイルシーンを作れます。Amazon 風の純白商品プレートと混同しないでください。その流れは EC ガイドにあります。",
      "切り抜きに薄い縁が残っていると、どの新しいシーンも偽物に見えます。まずエッジを直し、そのあと雰囲気を考えます。"
    ],
    "practice": [
      "透明の被写体が明るいキャンバスと暗いキャンバスの両方できれいに見えるまで、合成しません。",
      "「きれいさ」より先に光の方向を合わせます。窓光のポートレートをネオンの夜の街に載せても、ほとんど誰もだませません。"
    ],
    "compareIntro": "透明マスターには背景除去、ライフスタイルやカバーシーンにはこのガイド、証明写真風の色にはポートレートガイド、マーケットプレイスの白背景には EC ガイドを使ってください。",
    "workflow": "被写体を切り抜き、照明に合うシーンを選び、新しい環境を合成または生成し、書き出し前にコンタクトシャドウ、色温度、エッジを確認します。",
    "scenarioIntro": "まずシーンの目的を決め、完成クロップとは別に透明マスターを残してください。",
    "sec": {
      "tldrTitle": "実際にうまくいく順番",
      "tldrCols": [
        "ステップ",
        "残すもの",
        "注意"
      ],
      "tldrRows": [
        [
          "1. 背景除去",
          "Miral AI の透明 PNG マスター",
          "旧ハロは後のシーンをすべて壊す"
        ],
        [
          "2. シーン選択",
          "カフェ、オフィス、ブランドウォール、屋外",
          "ランダムな美学ではなく用途で選ぶ"
        ],
        [
          "3. 合成または生成",
          "ライフスタイルまたはカバー画像",
          "光の方向と色温度を合わせる"
        ],
        [
          "4. 確認",
          "公開できる書き出し",
          "エッジ、スケール、接地感"
        ],
        [
          "白プレートと分ける",
          "白 SKU は EC ガイド",
          "この記事はシーン差し替え向け"
        ]
      ],
      "tldrP": "背景変更は魔法のワンクリックではありません。Miral AI では Background Remover で被写体を切り出し、その被写体に新しい立ち位置を与えます。最初の仕事を飛ばすと、2つ目はほぼ必ず貼り付けに見えます。",
      "removeTitle": "ライフスタイル、ソーシャルカバー、イベントポスターはそれぞれ別のプレートが必要",
      "removeP1": "古い壁の色は髪やジャケットのエッジに残ります。安定した道は同じです。Miral AI Background Remover → 透明 PNG マスター → 用途に合う新しいシーン。マーケットプレイスの白商品プレートは EC ガイドへ。ここではありません。",
      "removeLifestyleP": "ライフスタイル背景変更が解決すること：カフェの光、窓際、家のコーナーは雰囲気を作りますが、散らかった元背景はフレーム全体を安く見せます。きれいに切り抜き、顔の光と合うシーンに人物を置いてください。",
      "galleryLifestyleCaption": "ライフスタイル例：左は透明マスター、右は明るいカフェシーンに合成した同じ人物。",
      "removeSocialP": "ソーシャルカバー背景変更が解決すること：Instagram、Xiaohongshu、LinkedIn ヘッダーには顔のクリアさとタイトル用の余白が必要です。散らかった寝室やオープオフィスは枠を埋めます。ブランドグラデーションや静かな色壁なら、人物を片側に置き、もう片側にコピー用スペースを残せます。",
      "gallerySocialCaption": "ソーシャルカバー例：左は透明マスター、右は見出し用スペースのあるブランドグラデーション壁。",
      "removePosterP": "イベントポスター背景変更が解決すること：ウェビナー、講座ローンチ、トーク告知には机の自撮りではなく、落ち着いたステージやブランドウォールが必要です。切り抜き後、タイトル用の余白がある柔らかいブランドプレートに人物を置き、必要なら GPT Image で文字を足します。",
      "galleryPosterCaption": "イベントポスター例：左は透明マスター、右はトークや講座カバー向けの柔らかいブランドウォール。",
      "removeTipTitle": "マスター、シーン、カバークロップは分ける",
      "removeTipText": "透明 PNG を1枚のカフェやグラデーション書き出しで上書きしないでください。来シーズンのポスターは同じ切り抜きを再利用すべきです。",
      "howTitle": "実務的なオンラインワークフロー",
      "howP": "まず Miral AI Background Remover で信頼できる透明被写体を作ります。次に背景タイプを選びます。単色が最速、実写プレートが次、AI 生成環境がいちばん柔軟です。書き出し前に、人物が背景と同じ世界の光を受けているか確認してください。",
      "howTipTitle": "装飾より光",
      "howTipText": "顔と戦う劇的なシーンより、光が合う静かな背景の方が勝ちます。",
      "sceneTitle": "クリックされやすいシーンの方向",
      "sceneCols": [
        "方向",
        "向いている用途",
        "注意"
      ],
      "sceneRows": [
        [
          "明るいカフェ / 窓際",
          "個人ブランドとライフスタイルカバー",
          "暖かい電球は肌をオレンジにしすぎることがある"
        ],
        [
          "静かなオフィス / 本棚のソフトぼかし",
          "LinkedIn と講座メンター画像",
          "背景の小道具は顔より静かであるべき"
        ],
        [
          "屋外の昼光と緑",
          "旅行、ウェルネス、ライフスタイル投稿",
          "元の光と戦う真昼の強いトップライトを避ける"
        ],
        [
          "単色またはソフトなブランドグラデーション壁",
          "イベントポスターとソーシャルヘッダー",
          "オーバーレイ文字用に十分なコントラストを保つ"
        ],
        [
          "ステージや基調講演の照明",
          "トーク告知",
          "フレアが顔を横切らないように"
        ],
        [
          "ホームライフスタイルのコーナー",
          "柔らかい商品ストーリー",
          "遠近と人物スケールを一貫させる"
        ]
      ],
      "sceneP": "クリックされやすいとは、多くはクリアで散らかっていないことです。意図のある静かな背景にきれいな人物がいる方が、忙しいコラージュより強いことが多いです。",
      "qualityTitle": "偽物が見える5つの場所",
      "qualityItems": [
        "髪と肩：旧部屋の白や色のフリンジが残っている。",
        "光の方向：顔のハイライトと窓光が一致すべき。",
        "色温度：暖かい室内の肌を冷たい青プレートに載せると分裂して見える。",
        "スケール：人物がステッカーのように浮いたり、間違った奥行きに縮んだりしない。",
        "接地：地面や椅子のコンタクトのヒントがあると合成が信じられる。"
      ],
      "qualityTipTitle": "早めにクロップをプレビュー",
      "qualityTipText": "最終シーンを決める前に、正方形アバターとワイドカバーのクロップを確認してください。",
      "vsTitle": "他ガイドとの分け方",
      "vsCols": [
        "ガイド",
        "主な仕事",
        "開くとき"
      ],
      "vsRows": [
        [
          "一般向け AI 背景除去",
          "任意の被写体 → 透明 PNG",
          "切り抜きだけが必要なとき"
        ],
        [
          "EC 商品背景",
          "白 / 透明の商品プレート",
          "Amazon、Shopify のリスティング準拠"
        ],
        [
          "ポートレート背景除去",
          "アバターと証明写真風の色",
          "顔、髪、白/青の証明写真マスター"
        ],
        [
          "AI 背景差し替え（この記事）",
          "切り抜き後のシーン差し替え",
          "カフェ、オフィス、ブランドウォールの雰囲気"
        ]
      ],
      "vsP": "4つのガイドは相互リンクしつつ、キーワードは正直に保ちます。白い商品プレートはライフスタイル記事に入れず、ビザ青の証明写真はカフェ合成の売り込みに入れません。",
      "troubleTitle": "新しいシーンがおかしいとき",
      "troubleCols": [
        "問題",
        "原因",
        "直し方"
      ],
      "troubleRows": [
        [
          "被写体まわりの明るいフリンジ",
          "切り抜きがまだ汚い",
          "コントラストの高いオリジナルで除去に戻る"
        ],
        [
          "ステッカーのように見える",
          "接地不足や光の不一致",
          "プレートを柔らかくするか、ごく薄いコンタクトシャドウを足す"
        ],
        [
          "肌がグレーやオレンジになる",
          "色温度の衝突",
          "近い温度のシーンを選ぶか、グレードを統一する"
        ],
        [
          "髪が汚く見える",
          "髪まわりのアルファが不完全",
          "再合成前に切り抜きをきれいにする"
        ],
        [
          "AI シーンで商品形状がずれる",
          "生成がオブジェクトを変えた",
          "アイデンティティを固定し、AI には環境だけを作らせる"
        ]
      ],
      "prosConsTitle": "このワークフローが開くもの",
      "bestTitle": "スマホ画面でも持たせる差し替え",
      "bestItems": [
        "きれいな透明マスターを絶対に飛ばさない。",
        "チャネルがシーンを決める：採用は静か、ライフスタイルは呼吸、ポスターはタイトル用スペース。",
        "シンプルな撮影光の方が差し替えやすい。",
        "投稿前にスマホサイズで必ずプレビューする。",
        "シーンが決まってから見出し文字を足す—GPT Image がポスター文字に役立つ。",
        "マーケットプレイスの白 SKU は EC ガイドへ送り、意図を分ける。"
      ],
      "miralTitle": "チェーンを Miral AI 内に保つ",
      "miralP": "Miral AI での推奨パス：Background Remover → 任意で Image Enhancer → 環境に Seedream または FLUX.2 → ポスター文字が必要なら GPT Image。証明写真風の白や青カードはポートレートガイドに戻ってください。",
      "miralLinksTitle": "次のステップ",
      "miralLinks": [
        {
          "label": "Miral AI Background Remover",
          "path": "/tools/background-remover"
        },
        {
          "label": "ポートレート・証明写真ガイド",
          "path": "/hub/articles/ai-portrait-background-remover"
        },
        {
          "label": "一般向けAI背景除去ガイド",
          "path": "/hub/articles/ai-background-remover-online"
        },
        {
          "label": "EC商品背景ガイド",
          "path": "/hub/articles/ecommerce-product-background-removal"
        },
        {
          "label": "AI Image Enhancer",
          "path": "/tools/image-enhancer"
        },
        {
          "label": "Seedream 5",
          "path": "/image-models/seedream-ai-image-generator"
        },
        {
          "label": "FLUX.2",
          "path": "/image-models/flux-2-ai-image-generator"
        },
        {
          "label": "GPT Image 1.5",
          "path": "/image-models/gpt-image-ai-image-generator"
        }
      ],
      "intentsTitle": "よくある背景変更の仕事",
      "faqTitle": "実務的な質問",
      "faqItems": [
        [
          "オンラインで写真背景を無料で変えるには？",
          "Miral AI にサインインし、Background Remover で透明 PNG を書き出し、カフェ、ブランドウォール、または新しいシーンに被写体を置きます。"
        ],
        [
          "透明 PNG からライフスタイル画像を作るには？",
          "光が合うプレートに合成し、接地と色温度を確認し、マスターとカバークロップを分けます。"
        ],
        [
          "切り抜き後にソーシャルカバー背景を変えるには？",
          "髪のエッジが確認を通ったら、ブランドグラデーションの片側に被写体を置き、タイトル用スペースを残します。"
        ],
        [
          "自撮りの背景をカフェシーンに差し替えられますか？",
          "はい。まずきれいに切り抜き、窓光が顔と合うカフェプレートに合成します。"
        ],
        [
          "実在の人物の後ろに新しい AI シーンを生成できますか？",
          "はい。透明 PNG の実在被写体を残し、Seedream または FLUX.2 には環境だけを作らせます。"
        ],
        [
          "イベントポスターの背景差し替えに使えるツールは？",
          "切り抜きは Miral AI Background Remover、柔らかいブランドウォールに配置し、必要なら GPT Image で見出し文字を足します。"
        ],
        [
          "ソーシャルカバー背景差し替えに使えるツールは？",
          "Background Remover にブランド色またはグラデーション壁。より豊かなライフスタイルシーンが必要なら Seedream または FLUX.2 へ。"
        ],
        [
          "偽物に見える背景合成を直すには？",
          "フリンジ、光の方向、色温度の順に確認します。エッジが汚いならまず背景除去に戻ります。"
        ],
        [
          "背景変更時の屋外昼光の不一致を直すには？",
          "太陽の方向を合わせ、室内光向けの顔に真昼の強いトップライトを当てないでください。"
        ],
        [
          "動画カバーに背景変更を使えますか？",
          "はい。カバー比率のクロップを書き出し、セーフエリア内に被写体を保ちます。"
        ],
        [
          "背景除去と背景変更の違いは？",
          "除去は透明の被写体を作ります。変更はその被写体を新しいシーンや色に置きます。"
        ],
        [
          "Amazon の白商品背景に使えますか？",
          "いいえ。マーケットプレイスの白プレートは EC ガイドへ。この記事はライフスタイルとカバーシーン向けです。"
        ]
      ]
    },
    "linksTitle": "Miral AI でシーンワークフローを組む",
    "linksIntro": "一度切り抜き、透明マスターを残し、マスクをやり直さずにライフスタイルシーン、カバー、ポスタープレートを作れます。",
    "links": [
      {
        "label": "Miral AI Background Remover",
        "path": "/tools/background-remover"
      },
      {
        "label": "ポートレート・証明写真ガイド",
        "path": "/hub/articles/ai-portrait-background-remover"
      },
      {
        "label": "一般向けAI背景除去ガイド",
        "path": "/hub/articles/ai-background-remover-online"
      },
      {
        "label": "EC商品背景ガイド",
        "path": "/hub/articles/ecommerce-product-background-removal"
      },
      {
        "label": "AI Image Enhancer",
        "path": "/tools/image-enhancer"
      },
      {
        "label": "Seedream 5",
        "path": "/image-models/seedream-ai-image-generator"
      },
      {
        "label": "FLUX.2",
        "path": "/image-models/flux-2-ai-image-generator"
      },
      {
        "label": "GPT Image 1.5",
        "path": "/image-models/gpt-image-ai-image-generator"
      }
    ],
    "steps": [
      {
        "title": "まずきれいな被写体を切り抜く",
        "text": "Miral AI Background Remover で透明 PNG をダウンロードし、髪や商品のエッジを確認します。"
      },
      {
        "title": "新しいシーンの雰囲気を決める",
        "text": "カフェ、静かなオフィス、屋外昼光、ブランドウォール—チャネル向けに選びます。"
      },
      {
        "title": "新しい背景に被写体を置く",
        "text": "デザインキャンバスで合成するか、光を合わせて Seedream / FLUX.2 で続けます。"
      },
      {
        "title": "光、スケール、接地を確認する",
        "text": "フリンジ、色の衝突、サイズの誤り、接地感の不足を見ます。"
      },
      {
        "title": "必要なクロップを書き出す",
        "text": "カバーとアバターサイズを別に保存し、透明マスターはそのまま残します。"
      }
    ],
    "pros": [
      "1枚の透明マスターで多くのシーンに対応",
      "毎回撮影し直すより安い",
      "ソーシャルカバーとライフスタイル枠に強い",
      "Seedream と FLUX.2 のシーン作業へ自然につながる"
    ],
    "cons": [
      "光の不一致はすぐ偽物に見える",
      "汚い切り抜きエッジが合成全体を壊す",
      "マーケットプレイスの白 SKU は EC ガイドを使うべき",
      "複雑な遠近シーンは手動の仕上げがまだ必要なことがある"
    ],
    "tips": [
      {
        "title": "雰囲気より先にエッジ",
        "text": "暗いキャンバスでまだハロが見える切り抜きを合成しないでください。"
      },
      {
        "title": "まず光を合わせる",
        "text": "顔や商品のキーライトと一致するプレートを選びます。"
      },
      {
        "title": "マスターを分ける",
        "text": "透明 PNG、ライフスタイル書き出し、ソーシャルクロップは別ファイルに。"
      },
      {
        "title": "文字用スペースを残す",
        "text": "ポスター背景には見出しが座れる静かなゾーンが必要です。"
      },
      {
        "title": "検索意図を分ける",
        "text": "Amazon の白プレートは EC 記事へ。この記事はシーン変更向けに保ちます。"
      }
    ],
    "scenarios": [
      {
        "title": "オンラインで写真背景を無料で差し替える",
        "text": "まず被写体を切り抜き、新しいプレートまたは生成シーンに置きます。"
      },
      {
        "title": "カフェのライフスタイルポートレート背景",
        "text": "顔の光に合う窓光のプレートを使います。"
      },
      {
        "title": "プロ写真用のオフィス背景",
        "text": "棚や小道具は人物より柔らかく保ちます。"
      },
      {
        "title": "ソーシャルカバー用のブランド色背景",
        "text": "タイトル用スペースのある単色またはソフトグラデーションに透明 PNG を載せます。"
      },
      {
        "title": "AI 切り抜き後に背景を変える",
        "text": "髪とジャケットのエッジが2キャンバス確認を通るまで合成しない。"
      },
      {
        "title": "実在人物の後ろに AI 生成シーン",
        "text": "Seedream または FLUX.2 には部屋だけを作らせ、新しい顔や服は作らせない。"
      },
      {
        "title": "イベントポスターの背景差し替え",
        "text": "見出しが読めるよう、きれいなブランドウォールを優先します。"
      },
      {
        "title": "屋外昼光の背景スワップ",
        "text": "太陽の方向を合わせ、柔らかい室内顔に真昼のトップライトを当てない。"
      },
      {
        "title": "偽物に見える背景合成を直す",
        "text": "フリンジ、光の方向、色温度の順に確認します。"
      },
      {
        "title": "透明 PNG からライフスタイル画像へ",
        "text": "マスターを保管し、カバークロップは別に書き出します。"
      },
      {
        "title": "Amazon 白背景向けではない",
        "text": "リスティングプレートは EC 商品ガイドへ送ります。"
      },
      {
        "title": "ポートレート切り抜き後のシーン変更",
        "text": "ポートレートワークフローで髪確認を終え、このシーンワークフローを開きます。"
      }
    ],
    "toolFaq": [
      {
        "q": "オンラインで写真背景を無料で変えるには？",
        "a": "サインインし、元背景を透明 PNG に除去し、新しいシーンまたは単色に被写体を置きます。"
      },
      {
        "q": "透明 PNG からライフスタイル画像を作るには？",
        "a": "光が合うプレートに合成し、接地と色温度を確認し、マスターをカバークロップと分けます。"
      },
      {
        "q": "自撮り背景をカフェシーンに差し替えられますか？",
        "a": "はい。まず人物を切り抜き、似た窓光のカフェプレートに合成します。"
      },
      {
        "q": "実在人物の後ろに新しい AI シーンを生成できますか？",
        "a": "はい。実在被写体を残し、Seedream または FLUX.2 には環境だけを作らせます。"
      },
      {
        "q": "イベントポスターの背景差し替えに使えるツールは？",
        "a": "切り抜きは Background Remover、静かなブランドウォールに配置し、必要なら見出し文字を足します。"
      },
      {
        "q": "ソーシャルカバー背景差し替えに使えるツールは？",
        "a": "Background Remover にブランド色またはグラデーション壁。より豊かなシーンは Seedream または FLUX.2 へ。"
      },
      {
        "q": "偽物に見える背景合成を直すには？",
        "a": "書き出し前にフリンジを掃除し、光の方向を合わせ、色温度を統一します。"
      },
      {
        "q": "背景変更時の屋外昼光の不一致を直すには？",
        "a": "太陽の方向を合わせ、室内光の顔に真昼のトップライトを避けます。"
      },
      {
        "q": "動画カバーに背景変更を使えますか？",
        "a": "はい。カバー比率のクロップを書き出し、セーフエリア内に被写体を保ちます。"
      },
      {
        "q": "Amazon の白商品背景に使えますか？",
        "a": "いいえ。マーケットプレイスの白プレートには EC 商品背景ガイドを使ってください。"
      }
    ]
  },
  "articles": {
    "ai-portrait-background-remover": {
      "title": "無料 AI ポートレート背景除去：ヘッドショット、アバター、証明写真",
      "excerpt": "散らかった自撮りをきれいなヘッドショットに。ポートレート背景を無料で除去し、透明 PNG を書き出し、LinkedIn・履歴書・アバター用に白・青・ブランド色を足します。",
      "metaTitle": "無料 AI ポートレート背景除去 | Miral",
      "metaDescription": "Miral AI でポートレート背景を無料除去。髪のディテールを残し、透明 PNG を書き出し、LinkedIn ヘッドショットや白・青の証明写真風を作れます。",
      "target": {
        "label": "ポートレート背景除去を開く",
        "path": "/tools/background-remover"
      },
      "keywords": [
        "無料ポートレート背景除去",
        "AIヘッドショット背景除去",
        "LinkedIn写真背景除去",
        "証明写真背景除去",
        "アバター背景除去",
        "髪まわり背景除去",
        "履歴書写真白背景",
        "青背景証明写真オンライン"
      ]
    },
    "ai-background-changer-online": {
      "title": "無料 AI 背景チェンジャー：ライフスタイル、ソーシャルカバー、イベントポスター",
      "excerpt": "古い背景を無料で除去し、カフェのライフスタイル、ブランドグラデーションのソーシャルカバー、イベントポスター壁に人物を配置—EC 白背景の意図とは分けます。",
      "metaTitle": "無料 AI 背景チェンジャー オンライン | Miral",
      "metaDescription": "Miral AI で写真背景をオンライン変更。透明 PNG に切り抜き、カフェのライフスタイル、ソーシャルカバー、イベントポスターシーンを作れます。",
      "target": {
        "label": "AI 背景除去を開く",
        "path": "/tools/background-remover"
      },
      "keywords": [
        "無料AI背景チェンジャー",
        "写真背景オンライン差し替え",
        "切り抜き後の背景変更",
        "AIシーン差し替え",
        "ライフスタイル背景チェンジャー",
        "ポートレート用カフェ背景",
        "ソーシャルカバー背景差し替え",
        "透明PNG新しい背景"
      ]
    }
  }
}
